import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../layers/support/LOD.js";
import i from "../../../../layers/support/TileInfo.js";

var s = /*#__PURE__*/function () {
  function s(e, i) {
    _classCallCheck(this, s);

    this.lockedSchemaPixelSize = e, this.isGCS = i;
  }

  _createClass(s, [{
    key: "getLevelRowColumn",
    value: function getLevelRowColumn(e) {
      return this.isGCS ? [e[0], e[1] >> 1, e[2] >> 1] : 256 === this.lockedSchemaPixelSize && e[0] > 0 ? [e[0] - 1, e[1] >> 1, e[2] >> 1] : e;
    }
  }, {
    key: "adjustLevel",
    value: function adjustLevel(e) {
      return this.isGCS ? e : 256 === this.lockedSchemaPixelSize ? e > 0 ? e - 1 : 0 : e;
    }
  }, {
    key: "getShift",
    value: function getShift(e, i) {
      var _s = 0,
          t = 0;
      return (256 === this.lockedSchemaPixelSize || this.isGCS) && (e[2] % 2 && (_s = i), e[1] % 2 && (t = i)), [_s, t];
    }
  }, {
    key: "getScale",
    value: function getScale(e) {
      if (this.isGCS) {
        if (512 === this.lockedSchemaPixelSize) return 4;
      } else if (256 === this.lockedSchemaPixelSize && 0 === e) return 1;

      return 2;
    }
  }], [{
    key: "create256x256CompatibleTileInfo",
    value: function create256x256CompatibleTileInfo(_s2) {
      if (!_s2) return null;
      if (256 === _s2.size[0] && 256 === _s2.size[1]) return _s2;
      var t = 256,
          l = _s2.spatialReference.isGeographic,
          r = [],
          o = _s2.lods.length;

      for (var _i = 0; _i < o; _i++) {
        var _t = _s2.lods[_i],
            _o = l ? _t.resolution : 2 * _t.resolution;

        r.push(new e({
          level: _t.level,
          scale: _t.scale,
          resolution: _o
        }));
      }

      return new i({
        size: [t, t],
        dpi: _s2.dpi,
        format: _s2.format,
        compressionQuality: _s2.compressionQuality,
        origin: _s2.origin,
        spatialReference: _s2.spatialReference,
        lods: r
      });
    }
  }, {
    key: "create512x512CompatibleTileInfo",
    value: function create512x512CompatibleTileInfo(_s3) {
      if (!_s3) return null;
      if (256 === _s3.size[0] || 256 === _s3.size[1]) return null;
      var t = 512,
          l = [],
          r = _s3.lods.length;

      for (var _i2 = 0; _i2 < r; _i2++) {
        var _t2 = _s3.lods[_i2],
            _r = .5 * _t2.resolution;

        l.push(new e({
          level: _t2.level,
          scale: _t2.scale,
          resolution: _r
        }));
      }

      return new i({
        size: [t, t],
        dpi: _s3.dpi,
        format: _s3.format,
        compressionQuality: _s3.compressionQuality,
        origin: _s3.origin,
        spatialReference: _s3.spatialReference,
        lods: l
      });
    }
  }]);

  return s;
}();

export { s as default };